import {isEmptyList, isNotEmpty, isNotEmptyList, nullToBlank} from "./CommonUtil.ts";

export const _CONST_LIST_SEARCH_KEY = "k";
export const _CONST_LIST_LARGE_CLASS = "lc";
export const _CONST_LIST_MEDIUM_CLASS = "mc";
export const _CONST_LIST_SMALL_CLASS = "sc";
export const _CONST_LIST_GIFT_BRANDS = "gbs";
export const _CONST_LIST_PRICE_RANGES = "prs";
export const _CONST_LIST_INDEX = "idx";
export const _CONST_LIST_LEVEL = "lv";

export const _INIT_LIST_SEARCH_DATA: any = {k: "", idx: 0};

const _SPLIT_STRING = "_";

/**
 * 連結文字列を配列に分割する
 * @param codes
 * @returns {string[]|*[]}
 */
export function splitCodeParams(codes: string | null) : string[] {
    if(isNotEmpty(codes)) {
        // @ts-ignore
        return codes.split(_SPLIT_STRING)
    } else {
        return []
    }
}


/**
 * 複数のコードをカンマ区切りで文字列に連結
 * @param codes
 * @param all
 * @returns {string}
 */
export function jointCodeParams(codes: [] | null ):string {
    const codeArray: any[] = [];
    if(!isEmptyList(codes)) {
        // @ts-ignore
        for (const code of codes) {
            codeArray.push(code);
        }
    }
    return codeArray.join(_SPLIT_STRING);
}


/**
 * 検索用のパラメータを設定する
 */
export function buildSearchParams(params: any, {
    keywords,
    page_index,
    large_class,
    medium_class,
    small_class,
    gift_brands = [],
    price_ranges = [],
}: any) {
    if(keywords !== undefined) {
        params.set(_CONST_LIST_SEARCH_KEY, keywords);

    }
    if(page_index !== undefined) {
        params.set(_CONST_LIST_INDEX, page_index);
    }

    if(large_class !== undefined) {
        params.set(_CONST_LIST_LARGE_CLASS, large_class);
    }
    if(medium_class !== undefined) {
        params.set(_CONST_LIST_MEDIUM_CLASS, medium_class);
    }
    if(small_class !== undefined) {
        params.set(_CONST_LIST_SMALL_CLASS, small_class);
    }

    if(gift_brands !== undefined) {
        params.set(_CONST_LIST_GIFT_BRANDS, jointCodeParams(gift_brands));
    }
    if(price_ranges !== undefined) {
        params.set(_CONST_LIST_PRICE_RANGES, jointCodeParams(price_ranges));
    }
    params.set("stop", true);
}

/**
 * 検索用のパラメータを設定する
 */
export function buildSearchUrl(params: any, {
    keywords,
    page_index,
    large_class,
    medium_class,
    small_class,
    gift_brands = [],
    price_ranges = [],
    sub_site_section = "",
}: any) {
    let queryUrl = "/goods/list/" + sub_site_section + "/?"
    queryUrl += _CONST_LIST_SEARCH_KEY + "=" + nullToBlank(keywords);
    queryUrl += "&" + _CONST_LIST_INDEX + "=" + nullToBlank(page_index);
    queryUrl += "&" + _CONST_LIST_LARGE_CLASS + "=" + nullToBlank(large_class);
    queryUrl += "&" + _CONST_LIST_MEDIUM_CLASS + "=" + nullToBlank(medium_class);
    queryUrl += "&" + _CONST_LIST_SMALL_CLASS + "=" + nullToBlank(small_class);
    queryUrl += "&" + _CONST_LIST_GIFT_BRANDS + "=" + jointCodeParams(gift_brands);
    queryUrl += "&" + _CONST_LIST_PRICE_RANGES + "=" + jointCodeParams(price_ranges);
    return queryUrl;
}


/**
 * URLパラメータを取得する
 */
export function getParam(params: URLSearchParams, key: string): string {
    let param = params.get(key);
    if(param == null) {
        return "";
    } else {
        return param;
    }
}

/**
 * 変更済みの検索条件をカウントする
 */
export function calcChangedCondition({
    keywords,
    large_class,
    medium_class,
    small_class,
    gift_brands = [],
    price_ranges = [],
}: any): number {
    let count: number  = 0;
    if(isNotEmpty(keywords)) {
        count++;
    }
    if(isNotEmpty(large_class)) {
        count++;
    }
    if(isNotEmpty(medium_class)) {
        count++;
    }
    if(isNotEmpty(small_class)) {
        count++;
    }
    if(isNotEmptyList(gift_brands)) {
        for (const giftBrand of gift_brands) {
            if(isNotEmpty(gift_brands)) {
                count++;
            }
        }
    }
    if(isNotEmptyList(price_ranges)) {
        for (const giftBrand of price_ranges) {
            if(isNotEmpty(price_ranges)) {
                count++;
            }
        }
    }
    return count;
}
